import React, {useEffect, useRef, useState} from 'react'
import {gsap} from 'gsap'
import Wing from './Wing'
import type {ColorClassKey} from './types'

interface ButterflyProps {
  DefaultColorClass: ColorClassKey
  pearlTrigger: boolean
  wingIntensity: number
  wingSpeedRatio: number
}

const Butterfly: React.FC<ButterflyProps> = ({DefaultColorClass, pearlTrigger, wingIntensity, wingSpeedRatio}) => {
  const wingRef1 = useRef<HTMLDivElement>(null)
  const wingRef2 = useRef<HTMLDivElement>(null)
  const [wingTl, setWingTl] = useState<gsap.core.Timeline | null>(null)
  const wingIntensityRef = useRef(wingIntensity)

  useEffect(() => {
    wingIntensityRef.current = wingIntensity
  }, [wingIntensity])

  useEffect(() => {
    if (wingTl) {
      wingTl.timeScale(wingSpeedRatio)
    }
  }, [wingSpeedRatio, wingTl])

  useEffect(() => {
    if (pearlTrigger) {
      const wing1 = wingRef1.current
      const wing2 = wingRef2.current

      if (wing1 && wing2) {
        const wd = 0.3

        const rotateProgress = {
          value: 0,
        }

        const tl = gsap.timeline({
          repeat: -1,
          defaults: {duration: wd},
          onUpdate: () => {
            gsap.set(wing1, {rotateY: -40 * rotateProgress.value * wingIntensityRef.current})
            gsap.set(wing2, {rotateY: 40 * rotateProgress.value * wingIntensityRef.current})
          },
        })

        tl.to(
          rotateProgress,
          {
            value: 1,
          },
          0,
        ).to(
          rotateProgress,
          {
            value: 0,
          },
          wd,
        )

        setWingTl(tl)
      }
    }
  }, [pearlTrigger])

  return (
    <>
      <Wing pearlTrigger={pearlTrigger} wingRef={wingRef1} DefaultColorClass={DefaultColorClass} />
      <Wing pearlTrigger={pearlTrigger} wingRef={wingRef2} DefaultColorClass={DefaultColorClass} />
    </>
  )
}

export default Butterfly
